<router-outlet />
<hotkeys-cheatsheet />
<pr-ai-scribe-recorder />
